module.exports = __webpack_public_path__ + "static/media/logo_enfoque_equidad_genero.99943eee.png";